import React from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { Box, Grid2 } from "@mui/material";
import {
  MyFulfilledLeaves,
  MyLeaveDetailsChart,
  MyLeaveLeaveCards,
  MyLeavePreviousFulfilledLeavesTable,
} from "my-leave/components";
import MyLeaveRequestsTable from "my-leave/components/my-leave-requests-table";
import { useMyLeaveExaminersName } from "my-leave/hooks";
import {
  OcCard,
  OcExaminersList,
  OcPageNameTitle,
  OcPageTransition,
} from "oc/components";
import { useOcIsMobile } from "oc/hooks";
import { ocCurrentUserState } from "oc/states";

export const MyLeaveMyRequestsPage = () => {
  let thisYear = new Date().getFullYear();
  const { t, i18n } = useTranslation();
  let { contractCode } = useRecoilValue(ocCurrentUserState);
  const isMobile = useOcIsMobile();

  const {
    data: examinersData,
    loading: examinersLoading,
    error: examinersError,
  } = useMyLeaveExaminersName({ locale: i18n.language });

  let disabledNewRequest = false;

  return (
    <OcPageTransition>
      <OcPageNameTitle
        title={t("MY_LEAVE_MY_LEAVE_REQUESTS_PAGE_TITLE")}
        goBack={false}
      />
      <Box>
        <Grid2
          container
          spacing={0}
          style={{
            flexDirection: isMobile ? "column" : "unset",
            flexWrap: isMobile ? "wrap" : "nowrap",
            padding: isMobile ? "0px 0px 16px 0px" : "0px 8px 8px 8px",
          }}
        >
          <Grid2
            size={{ xs: 12, sm: 5, md: 5, lg: 5 }}
            style={{
              maxWidth: isMobile ? "100%" : "41.666667%",
              padding: isMobile ? "0px 0px 16px 0px" : "0px 8px 8px 8px",
            }}
          >
            <OcCard label={t("MY_LEAVE_LEAVE_SUMMARY")}>
              <MyLeaveLeaveCards
                selectedYear={thisYear}
                contractCode={contractCode}
              />
            </OcCard>
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 5, md: 5, lg: 5 }}
            style={{
              maxWidth: isMobile ? "100%" : "41.666667%",
              padding: isMobile ? "0px 0px 16px 0px" : "0px 8px 8px 8px",
            }}
          >
            <Box id="leave-details-chart">
              <OcCard label={t("MY_LEAVE_LEAVE_DETAILS")}>
                <MyLeaveDetailsChart selectedYear={thisYear} />
              </OcCard>
            </Box>
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 5, md: 5, lg: 5 }}
            style={{
              maxWidth: isMobile ? "100%" : "16.666667%",
              padding: isMobile ? "0px 0px 16px 0px" : "0px 8px 8px 8px",
            }}
          >
            <OcCard
              label={t("OC_EXAMINERS")}
              loading={!examinersData && examinersLoading}
              error={!!examinersError}
            >
              <>
                <OcExaminersList
                  examinersData={examinersData}
                  loading={examinersLoading}
                />
              </>
            </OcCard>
          </Grid2>
        </Grid2>
        <Box padding={isMobile ? "unset" : "16px"}>
          <OcCard label={t("MY_LEAVE_MY_LEAVES_AND_ABSENCES")}>
            <MyLeaveRequestsTable
              selectedYear={thisYear}
              disabledNewRequest={disabledNewRequest}
              isMobile={isMobile}
            />
          </OcCard>
          <Box height="16px" />
          <OcCard label={t("MY_LEAVE_MY_FULFILLED_LEAVES_AND_ABSENCES")}>
            <MyFulfilledLeaves selectedYear={thisYear} isMobile={isMobile} />
          </OcCard>
          <Box height="16px" />
          <OcCard label={t("MY_LEAVE_MY_PREVIOUS_LEAVES")}>
            <MyLeavePreviousFulfilledLeavesTable isMobile={isMobile} />
          </OcCard>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyLeaveMyRequestsPage;
